import { RiskBadge } from '../ui/RiskBadge';
import type { UserSummary } from '../../types/org.types';

function formatLogin(date: string | null): string {
  if (!date) return 'Never';
  const d = new Date(date);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function UsersTable({ rows }: { rows: UserSummary[] }) {
  if (rows.length === 0) return <div className="text-sm text-neutral-500 py-6">No users matched.</div>;
  return (
    <div className="border border-border rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-surface-2">
          <tr className="text-[11px] uppercase tracking-widest text-neutral-500">
            <th className="text-left px-4 py-3 font-medium">Name</th>
            <th className="text-left px-4 py-3 font-medium">Profile</th>
            <th className="text-left px-4 py-3 font-medium">License</th>
            <th className="text-left px-4 py-3 font-medium">Last login</th>
            <th className="text-left px-4 py-3 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((u, i) => (
            <tr key={u.id} className={i % 2 === 0 ? 'bg-surface-1/40' : 'bg-transparent'}>
              <td className="px-4 py-2.5">
                <div className="text-crux-light">{u.name}</div>
                <div className="text-[11px] text-neutral-600">{u.email ?? '-'}</div>
              </td>
              <td className="px-4 py-2.5 text-neutral-400">{u.profileName ?? '-'}</td>
              <td className="px-4 py-2.5 text-neutral-400">{u.licenseName ?? '-'}</td>
              <td className="px-4 py-2.5 text-neutral-400">{formatLogin(u.lastLoginDate)}</td>
              <td className="px-4 py-2.5">
                <RiskBadge tone={u.isActive ? 'healthy' : 'inactive'}>
                  {u.isActive ? 'Active' : 'Inactive'}
                </RiskBadge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
